import { render, staticRenderFns } from "./MenuSearch.vue?vue&type=template&id=3c488e8a&"
import script from "./MenuSearch.vue?vue&type=script&lang=js&"
export * from "./MenuSearch.vue?vue&type=script&lang=js&"
import style0 from "./MenuSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports